import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (this.isDismissed()) {
      this.element.remove()
    }
  }

  dismiss() {
    document.cookie = "password_banner_dismissed=1; path=/; max-age=2592000" // 30 days
    this.element.remove()
  }

  isDismissed() {
    return document.cookie.includes("password_banner_dismissed=1")
  }
}
